import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges, input, model, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';

import { CanDirective } from '@/core/permissions/can.directive';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
/** Diálogo de edição do "texto importante" associado à ata (semeia o campo ao abrir e emite o texto confirmado). */
@Component({
    selector: 'app-ata-dialog-importante',
    standalone: true,
    imports: [DialogoPadraoDirective, FormsModule, ButtonModule, DialogModule, InputTextModule, CanDirective],
    templateUrl: './ata-dialog-importante.html',
    styleUrls: ['./ata-dialog-importante.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AtaDialogImportanteComponent implements OnChanges {
    /** Visibilidade do diálogo (two-way `[(visivel)]`). */
    readonly visivel = model(false);
    /** Texto atual da ata (semeia o campo ao abrir). */
    readonly textoInicial = input('');
    /** Emite o texto confirmado. */
    readonly confirmar = output<string>();

    protected readonly roleAtasEditar = PERMISSOES.comissoes.atas.editar;

    protected readonly texto = signal('');

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['visivel'] && this.visivel()) {
            this.texto.set(this.textoInicial());
        }
    }

    protected fechar(): void {
        this.visivel.set(false);
    }

    protected aoConfirmar(): void {
        this.confirmar.emit(this.texto());
        this.fechar();
    }
}
